import React from 'react'
import ReactSVG from 'react-svg'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { path } from 'ramda'

import { getFormattedDate } from '../utils/get-formatted-date'
import { ACCOUNT_SCREENS } from '../../../constants'
import backArrowLeft from '../../../../images/back-arrow-left.svg'
import styles from '../cancel-subscription.css'

function SubscriptionInfo({ activeSubscription }) {
  const formattedStartDate = getFormattedDate(['currentSubscription', 'startsAt'], activeSubscription)
  const formattedEndDate = getFormattedDate(['currentSubscription', 'endsAt'], activeSubscription)
  const currentSubscriptionName = path(['currentSubscription', 'name'], activeSubscription)

  return (
    <>
      <NavLink
        to={ACCOUNT_SCREENS.SUBSCRIPTION_PAYMENT.path}
        className={styles.link}
      >
        <ReactSVG src={backArrowLeft} />
        <span className={styles.linkText}>
          {ACCOUNT_SCREENS.SUBSCRIPTION_PAYMENT.name}
        </span>
      </NavLink>

      <div className={styles.section}>
        <span className={styles.badge}>
          Subscriber since&nbsp;
          {formattedStartDate}
        </span>
        <div className={styles.header}>
          Manage Your Subscription
        </div>
        <div className={styles.copy}>
          If you make changes, you&apos;ll still have access to your current&nbsp;
          <span className={styles.bold}>
            {currentSubscriptionName}
            &nbsp;plan
          </span>
          &nbsp;until&nbsp;
          <span className={styles.bold}>{formattedEndDate}</span>
          . You will lose any promotions currently applied to your plan.
          <br />
          <br />
          Remember, you can rent movies with NEON at any time before or after this date.
        </div>
      </div>
    </>
  )
}

SubscriptionInfo.propTypes = {
  activeSubscription: PropTypes.oneOfType([PropTypes.object]).isRequired
}

export default SubscriptionInfo
